/* eslint-disable no-invalid-this */
/* eslint-disable require-jsdoc */
import React, { PureComponent } from 'react';
import { ControlDirection, ControlType } from '../../util';
import './index.scss';
interface AngleDashboardProps {
  onChange: AnyFunc;
  visible: boolean;
  heading?: number;
}

const btnGroup = [
  {
    cls: 'turn-left-btn',
    direc: ControlDirection.TURN_LEFT,
  },
  {
    cls: 'turn-right-btn',
    direc: ControlDirection.TURN_RIGHT,
  },
  {
    cls: 'back-to-normal',
    direc: ControlDirection.BACK_TO_NORMAL,
  },
];

class AngleDashboard extends PureComponent<AngleDashboardProps, any> {
  constructor(props: AngleDashboardProps) {
    super(props);
    this.state = {
      angle: 0,
    };
  }

  handleChange = (
    direc: ControlDirection,
    trigger: 'click' | 'keyboard' = 'click',
    key?: string,
  ) => {
    let realAngle = this.state.angle;
    if (direc === ControlDirection.TURN_LEFT) {
      // 左转
      if (realAngle < 30) {
        realAngle += 5;
      }
    } else if (direc === ControlDirection.TURN_RIGHT) {
      // 右转
      if (realAngle > -30) {
        realAngle -= 5;
      }
    } else if (direc === ControlDirection.BACK_TO_NORMAL) {
      // 拨正
      realAngle = 0;
    }

    this.setState(
      {
        angle: realAngle,
      },
      () => {
        this.props.onChange &&
          this.props.onChange(
            ControlType.ANGLE,
            realAngle,
            direc,
            trigger,
            key,
          );
      },
    );
  };

  handleDealWithKeyboardEventCode = (event: any) => {
    const keyCode = event.code;
    switch (keyCode) {
      case 'ArrowLeft':
        this.handleChange(ControlDirection.TURN_LEFT, 'keyboard', keyCode);
        break;
      case 'ArrowRight':
        this.handleChange(ControlDirection.TURN_RIGHT, 'keyboard', keyCode);
        break;
      case 'KeyZ':
        this.handleChange(ControlDirection.BACK_TO_NORMAL, 'keyboard', keyCode);
        break;
      default:
        return;
    }
  };

  resetAngle = () => {
    this.setState({
      angle: 0,
    });
  };

  componentDidUpdate(
    prevProps: Readonly<AngleDashboardProps>,
    prevState: Readonly<any>,
    snapshot?: any,
  ): void {
    if (prevProps.visible !== this.props.visible) {
      if (prevProps.visible) {
        document.addEventListener(
          'keyup',
          this.handleDealWithKeyboardEventCode,
        );
      } else {
        document.removeEventListener(
          'keyup',
          this.handleDealWithKeyboardEventCode,
        );
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleDealWithKeyboardEventCode);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleDealWithKeyboardEventCode);
  }

  render() {
    const { angle } = this.state;
    const { heading } = this.props;
    const targetAngleRotateStyle = {
      transform: `rotate(${-angle}deg)`,
    };

    const realtimeRotateStyle = {
      transform: `rotate(${heading}deg)`,
    };

    return (
      <div className='angle-dashboard'>
        <i className='angle-dashboard-icon'></i>
        <div className='angle-direction'>
          <div className='board-title'>方向</div>
          <div className='center-box'>
            <div className='realtime-angle'>
              <span>实时</span>
              <span>{(heading && parseFloat(heading.toFixed(2))) || '0'}°</span>
            </div>
            <div className='target-angle'>
              <span>目标</span>
              <span>{angle}°</span>
            </div>
          </div>
        </div>
        <div className='angle-pointer'>
          <i className='target-angle-pointer' style={targetAngleRotateStyle} />
          <i className='realtime-angle-pointer' style={realtimeRotateStyle} />
        </div>
        <div className='control-btn-group'>
          {btnGroup.map((item: any, index: number) => (
            <i
              key={index}
              className={item.cls}
              onClick={() => this.handleChange(item.direc)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default AngleDashboard;
